export default (editor) => {
  const value = editor?.value;
  const { focusBlock, selection, previousText } = value || {};

  if (!focusBlock) return false;
  const focusBlockKey = focusBlock.key;
  const offsetCursor = selection?.anchor?.offset;

  editor?.moveBackward(1);

  const newValue = editor?.value || {};
  const focusBlockPrevious = newValue?.focusBlock;
  const focusBlockKeyPrevious = focusBlockPrevious?.key;

  if (focusBlockKey !== focusBlockKeyPrevious) {
    editor?.select(selection);
    return true;
  }
  if (focusBlockKey !== focusBlockKeyPrevious && !offsetCursor) {
    editor?.select(selection);

    return true;
  }
  if (
    focusBlockKey === focusBlockKeyPrevious &&
    !offsetCursor &&
    !previousText
  ) {
    editor?.select(selection);

    return true;
  }

  editor?.select(selection);
  return false;
};
